// @flow
import React from 'react';

type Props = {
    className: string,
    vertical: boolean,
    offset: number,
    style: Object,
    disabled: boolean,
    min: number,
    max: number,
    value: ?number,
    index: number,
    dragging?: number
};

const SliderHandle = (props: Props) => {
    const {
        className,
        vertical,
        offset,
        style,
        disabled,
        min,
        max,
        value,
        index,
        ...restProps
    } = props;

    // we don't need this prop, but rc-slider wants you to pass the rest of the props
    // as html attributes on your slider div
    delete restProps.dragging;

    const postionStyle = vertical
        ? {bottom: `${offset}%`}
        : {left: `${offset}%`};
    const elStyle = {
        ...style,
        ...postionStyle
    };
    let ariaProps = {};
    if (value) {
        ariaProps = {
            ...ariaProps,
            'aria-valuemin': min,
            'aria-valuemax': max,
            'aria-valuenow': value,
            'aria-disabled': !!disabled
        };
    }
    return (
        <div
            className="rc-slider-handle-target"
            role="slider"
            tabIndex="0"
            key={index}
            data-wdio={`rc-slider-handle-target-${index}`}
            {...ariaProps}
            {...restProps}
            style={elStyle}
        >
            <div className={className} />
        </div>
    );
};

export default SliderHandle;
